import { Box } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { pt } from "date-fns/locale";
import { Controller } from "react-hook-form";
import { UseFormReturn } from "react-hook-form";
import { AvailabilityPreferences } from "../../utils/types";

type ChoseStartDateProps = {
    entityForm: UseFormReturn<AvailabilityPreferences>;
};

export const ChoseStartDate = ({ entityForm }: ChoseStartDateProps) => {
    const { control } = entityForm;
    return (
        <Box>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={pt}>
                <Controller
                    name="startDate"
                    control={control}
                    render={({ field }) => (
                        <DatePicker
                            label="Procurar a partir de"
                            value={field.value}
                            onChange={(newValue) => field.onChange(newValue || new Date())}
                            // minDate={new Date()}
                            slotProps={{
                                textField: { fullWidth: true },
                            }}
                        />
                    )}
                />
            </LocalizationProvider>
        </Box>
    );
};
